const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 16,
    boxShadow: 'none',
  }),
  button: {
    marginTop: 30,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/profile/styles.js